module.exports = __webpack_public_path__ + "img/8.bd6c6d85.gif";